const navigate = require('./navigate');
const lookup = require('./lookup');

module.exports = {
    lookup,
    navigate
};